import { buildWorkforceConfig, type AuthEnv } from '@brush/auth';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID ?? '';

const env: AuthEnv = {
  clientId,
  tenant: import.meta.env.VITE_ENTRA_TENANT ?? '',
  redirectUri: window.location.origin,
  apiScope: import.meta.env.VITE_API_SCOPE ?? '',
};

/** Skip MSAL for local dev against the dev-bypass API (see admin-web for the rationale). */
export const authDisabled =
  import.meta.env.VITE_AUTH_DISABLED === 'true' ||
  !clientId ||
  clientId === '00000000-0000-0000-0000-000000000000';

export const msalConfig = buildWorkforceConfig(env);
export const apiScope = env.apiScope;
/** Empty base URL routes through the Vite dev proxy (/api -> :5080). */
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
/** Dev only: pin room-web to one room. In production the room comes from identity. */
export const pinnedRoomId = import.meta.env.VITE_ROOM_ID ?? '';

/**
 * Where the player portal lives, for the sign-in door's routing line.
 *
 * Per environment rather than a literal: the player app is `stg.brushpoker.com` from staging and
 * its own host in production, so a hard-coded address would send one deployment's staff to
 * another's. Empty is an ordinary state — local dev, and any build that has not been told — and
 * the door words itself without an address rather than offering a link that answers nothing.
 */
export const playerWebUrl = import.meta.env.VITE_PLAYER_WEB_URL ?? '';
